import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularShield: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_shield"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="shield icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M11.7226 4.08397C11.8906 3.97201 12.1094 3.97201 12.2774 4.08397C14.2155 5.3761 16.3117 6.1823 18.5707 6.50503C18.817 6.54021 19 6.75117 19 7V11.5C19 15.3913 16.693 18.2307 12.1795 19.9667C12.064 20.0111 11.936 20.0111 11.8205 19.9667C7.30699 18.2307 5 15.3913 5 11.5V7C5 6.75117 5.18296 6.54021 5.42929 6.50503C7.68833 6.1823 9.78446 5.3761 11.7226 4.08397ZM11.5991 5.34583C9.85275 6.39606 7.98541 7.09055 6 7.42787V11.5C6 14.892 7.96795 17.3634 12 18.9632C16.0321 17.3634 18 14.892 18 11.5V7.42787C16.0146 7.09055 14.1473 6.39606 12.4009 5.34583L12 5.09715L11.5991 5.34583Z" />
      </svg>
    </span>
  );
};

export { RegularShield };
